import { SET_SEARCH_TAB_ACTION } from "./reducersConstants";
import { SEARCH_TAB_ID_CRM } from "../utils/constants";

export const setSearchTabAction = (data) => {
  return {
    type: SET_SEARCH_TAB_ACTION,
    data,
  };
};

export const searchTabReducer = (previousState = SEARCH_TAB_ID_CRM, { type, data }) => {
  switch (type) {
    case SET_SEARCH_TAB_ACTION:
      return data;
    default:
      return previousState;
  }
};
